<div class="emperor-ui-bcs-dialog-header">
  <h1>{{ config.data?.naicsDescription }}</h1>
  <emperor-button [uiButtonType]="EmperorUIButtonTypes.Fab" emperorDialogClose>
    <emperor-icon name="close_1"></emperor-icon>
  </emperor-button>
</div>
<div [innerHTML]="sanitizedExplanation()"></div>
